<template>
  <PopupBackground @click="$emit('close')">
    <div class="duplicate-console-popup smooth-shadow">
      <!-- Header -->
      <div class="header">
        <div class="title">
          <icon size="30">timelapse</icon>
          <h3>{{ layerToEdit ? "Edit" : "Add" }} Time Spent Analysis</h3>
        </div>
      </div>
      <div class="contents">
        <label>Layer Name</label>
        <input
          type="text"
          v-model="layerName"
          placeholder="Enter the layer name"
          ref="inputName"
        />
        <label>Entity</label>
        <DropDown
          v-model="selectedEntity"
          placeholder="Entity Type"
          :options="entityOptions"
          class="mb-10"
        />
        <!-- <div class="eventsPicker"> -->
        <!-- <div class="flex-col"> -->
        <label>Start Event</label>
        <DropDown
          v-model="startEvent"
          placeholder="Start Event"
          :options="eventOptions"
          class="mb-10"
        />
        <!-- </div> -->
        <!-- <div class="flex-col"> -->
        <label>End Event</label>
        <DropDown
          v-model="endEvent"
          placeholder="End Event"
          :options="eventOptions"
          class="mb-10"
        />
        <!-- </div> -->
        <!-- </div> -->
      </div>
      <!-- Footer -->
      <div class="footer">
        <expand />
        <Button
          v-if="!isRequestInProgress"
          type="secondary"
          :text="layerToEdit ? 'Cancel' : 'Go Back'"
          :icon="layerToEdit ? 'clear' : 'arrow_back'"
          @click="handleBack"
        />
        <spinner v-if="isRequestInProgress" />
        <Button
          v-else
          type="primary"
          :text="layerToEdit ? 'Save Layer' : 'Add Layer'"
          icon="check"
          @click="addLayerToStore"
          :disabled="isButtonDisabled"
        />
      </div>
    </div>
  </PopupBackground>
</template>

<script>
import PopupBackground from "@/components/modals/PopupBackground";
import Button from "@/components/global/views/Button";
import { TimeSpent } from "@/models/StaticEntityAnalysis/layers";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    PopupBackground,
    Button,
  },
  props: {
    layerToEdit: Object,
  },
  data() {
    return {
      isRequestInProgress: false,
      layerName: "",
      selectedEntity: null,
      startEvent: null,
      endEvent: null,
      hasRadiusFilter: true,
      radius: "50",
    };
  },
  computed: {
    ...mapGetters("Entities", ["getEntities"]),
    entityOptions() {
      return this.getEntities.map(entity => ({
        id: entity.id,
        name: entity.name,
      }));
    },
    eventOptions() {
      if (this.selectedEntity) {
        return this.getEntities.find(
          entity => entity.id === this.selectedEntity.id
        ).meta.lookup_view.event_col_options;
      } else {
        return null;
      }
    },
    isButtonDisabled() {
      return !(
        this.layerName &&
        this.selectedEntity &&
        this.startEvent &&
        this.endEvent
      );
    },
  },
  methods: {
    ...mapActions("StaticEntity", ["addLayer", "updateLayer"]),
    addLayerToStore() {
      const newTimeSpentLayer = new TimeSpent({
        id: this.layerToEdit ? this.layerToEdit.id : null,
        name: this.layerName,
        static_entity: [],
        entity: this.selectedEntity,
        start_event: this.startEvent,
        end_event: this.endEvent,
      });

      if (this.layerToEdit) {
        // Update the layer:
        this.updateLayer(newTimeSpentLayer);
      } else {
        // Create a new layer:
        this.addLayer(newTimeSpentLayer);
      }
      this.$emit("close");
    },
    handleBack() {
      this.$emit("close");
      this.$emit("openParent");
    },
  },
  mounted() {},
  watch: {
    layerToEdit: {
      immediate: true,
      handler(layer) {
        if (layer) {
          this.layerName = layer.name;
          this.selectedEntity = layer.entity;
          this.startEvent = layer.start_event;
          this.endEvent = layer.end_event;
        }
      },
    },
    selectedEntity() {
      this.startEvent = null;
      this.endEvent = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.duplicate-console-popup {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  width: 80%;
  max-width: 450px;

  .header,
  .footer,
  .contents {
    padding: 10px;
  }

  .header {
    padding: 20px 15px 10px 15px;
    display: flex;
    align-items: center;

    .title {
      display: flex;
      /* flex-direction: column; */
      align-items: center;

      i {
        margin-right: 10px;
      }

      h3 {
        font-weight: bold;
      }

      p {
        margin: 0;
        opacity: 0.8;
        padding: 10px 0 0 0;
      }
    }
  }

  .contents {
    display: flex;
    flex-direction: column;
    padding: 15px;

    label {
      margin: 0 0 5px 0;
    }
    input {
      margin: 0 0 10px 0;
    }
    .mb-10 {
      margin-bottom: 10px;
    }

    .eventsPicker {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 15px;
    }

    .radiusPicker {
      display: flex;
      align-items: center;

      input[type="text"] {
        margin-left: 10px;
        max-width: 50px;
      }
    }
  }

  .footer {
    background-color: var(--color-default-background);
    display: flex;
    align-items: center;
    border-radius: 0 0 5px 5px;
  }
}
</style>
